var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',[_c('v-card-title',[_vm._v("We apologize")]),_c('v-card-subtitle',[_vm._v("You got off the beaten path somehow.")]),_c('v-card-text',[_vm._v("The logo at the top is a button to start over.")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }